export default "__VITE_ASSET__Dt09DONG__"